// extracted by mini-css-extract-plugin
module.exports = {"tag-list":"TagList_tag-list__yRGtW"};